import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { ApplicantInterviewerEvaluations } from '@app/modules/applicant-tracker/enums/applicant-interviewer-evaluations.enum';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { StatusDisplayOptions } from '@app/types/translatables/applicant-tracker/status-display.options';

export class EvaluationColumn extends BadgeColumn<ApplicantInterviewers> {
    title = 'applicant-tracker.evaluation';
    property = null;
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(applicantInterviewers: ApplicantInterviewers): BadgeDisplay | undefined {
        if (applicantInterviewers.evaluation === ApplicantInterviewerEvaluations.passed) {
            return {
                type: 'success',
                label: StatusDisplayOptions['passed'],
            };
        }

        if (applicantInterviewers.evaluation === ApplicantInterviewerEvaluations.failed) {
            return {
                type: 'danger',
                label: StatusDisplayOptions['failed'],
            };
        }

        return {
            type: 'default',
            label: StatusDisplayOptions[applicantInterviewers.evaluation] ?? applicantInterviewers.evaluation,
        };
    }
}
